var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect, _rect2, _path17, _path18, _rect3, _rect4, _path19, _path20, _path21, _path22, _rect5, _rect6, _rect7, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _rect8, _polygon, _polygon2, _path30, _path31, _path32;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 345.53 300.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#c6c6c6;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.81px;stroke-dasharray:4.49 4.49;}.cls-2{fill:#95c11f;}.cls-3{fill:#00608e;}.cls-20,.cls-4{fill:#e73e20;}.cls-5{fill:#004060;}.cls-6{fill:#fff;}.cls-7{fill:#3c3c3b;}.cls-8{fill:#00b1eb;}.cls-9{fill:#002e47;}.cls-10{fill:#b6cbd8;}.cls-11{fill:#cdeafc;}.cls-12{fill:#001b2c;}.cls-13{fill:#7199ad;}.cls-14{fill:#002e43;}.cls-15{fill:#abc3d1;}.cls-16{fill:#57c4f2;}.cls-17{fill:#f7b288;}.cls-18,.cls-19{fill:#2e2d2c;}.cls-19,.cls-20{fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.82,266.87A48.59,48.59,0,1,0,98.4,218.29,48.58,48.58,0,0,0,49.82,266.87Z",
    transform: "translate(-39.83 -34.98)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.39,232.42a53,53,0,0,0,3.76,6c10.75-1,14.85,3,14.51,13.73a52.81,52.81,0,0,0,6.44,3.53c8.59-5.61,14.14-4.15,19.35,4.8,1,0,1.94.08,2.92.08,1.73,0,3.43-.09,5.12-.25,4.79-8.75,10.22-10.31,18.69-5.37a52.29,52.29,0,0,0,6.65-4c-.28-9.65,3.58-13.51,13.23-13.23a52.29,52.29,0,0,0,4-6.65c-5-8.47-3.38-13.9,5.37-18.69.16-1.69.25-3.39.25-5.12,0-1,0-1.95-.08-2.92-8.95-5.2-10.42-10.76-4.79-19.35a53.5,53.5,0,0,0-3.54-6.44c-10.73.34-14.69-3.76-13.73-14.51a53,53,0,0,0-6-3.76c-9.61,6-15.35,4.32-20.35-6.07-1.58-.14-3.17-.23-4.78-.23-.84,0-1.67,0-2.5.07-5.49,10.59-11.35,12.18-21.05,5.42a52.63,52.63,0,0,0-5.84,3.36c1,11.89-3.15,16.09-15,15a53.55,53.55,0,0,0-3.36,5.84c6.75,9.7,5.17,15.56-5.42,21,0,.83-.06,1.66-.06,2.5,0,1.61.08,3.2.22,4.78C111.7,217.07,113.4,222.81,107.39,232.42Zm9.69-25.13a37.29,37.29,0,1,1,37.29,37.29A37.28,37.28,0,0,1,117.08,207.29Z",
    transform: "translate(-39.83 -34.98)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.37,247.36a29.35,29.35,0,0,0,2.12,3.37c6-.54,8.34,1.69,8.15,7.72a30.36,30.36,0,0,0,3.63,2c4.82-3.16,7.94-2.34,10.87,2.69.54,0,1.09.05,1.64.05,1,0,1.93-.05,2.88-.14,2.69-4.92,5.74-5.8,10.5-3a29.41,29.41,0,0,0,3.75-2.23c-.16-5.42,2-7.59,7.43-7.43a31.27,31.27,0,0,0,2.23-3.74c-2.78-4.76-1.9-7.81,3-10.51.09-1,.14-1.91.14-2.88,0-.55,0-1.1,0-1.64-5-2.92-5.85-6.05-2.69-10.88a31,31,0,0,0-2-3.62c-6,.2-8.26-2.11-7.72-8.15a29.35,29.35,0,0,0-3.37-2.12c-5.4,3.38-8.63,2.43-11.44-3.41-.89-.08-1.78-.13-2.69-.13-.47,0-.94,0-1.4,0-3.09,6-6.38,6.85-11.84,3.05a30.27,30.27,0,0,0-3.28,1.88c.59,6.69-1.77,9.05-8.46,8.46A31.26,31.26,0,0,0,42.92,220c3.79,5.46,2.9,8.75-3.05,11.84,0,.47,0,.93,0,1.4,0,.91.05,1.8.13,2.69C45.8,238.73,46.75,242,43.37,247.36Zm5.9-14.13a20.51,20.51,0,1,1,20.51,20.51A20.51,20.51,0,0,1,49.27,233.23Z",
    transform: "translate(-39.83 -34.98)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80.37,319.36a29.35,29.35,0,0,0,2.12,3.37c6-.54,8.34,1.69,8.15,7.72a30.36,30.36,0,0,0,3.63,2c4.82-3.16,7.94-2.34,10.87,2.69.54,0,1.09.05,1.64.05,1,0,1.93-.05,2.88-.14,2.69-4.92,5.74-5.8,10.5-3a29.41,29.41,0,0,0,3.75-2.23c-.16-5.42,2-7.59,7.43-7.43a31.27,31.27,0,0,0,2.23-3.74c-2.78-4.76-1.9-7.81,3-10.51.09-.95.14-1.91.14-2.88,0-.55,0-1.1,0-1.64-5-2.92-5.85-6-2.69-10.88a31,31,0,0,0-2-3.62c-6,.2-8.26-2.11-7.72-8.15a29.35,29.35,0,0,0-3.37-2.12c-5.4,3.38-8.63,2.43-11.44-3.41-.89-.08-1.78-.13-2.69-.13-.47,0-.94,0-1.4,0-3.09,5.95-6.38,6.85-11.84,3.05a30.27,30.27,0,0,0-3.28,1.88c.59,6.69-1.77,9.05-8.46,8.46A31.26,31.26,0,0,0,79.92,292c3.79,5.46,2.9,8.75-3,11.84,0,.47,0,.93,0,1.4,0,.91,0,1.8.13,2.69C82.8,310.73,83.75,314,80.37,319.36Zm5.9-14.13a20.51,20.51,0,1,1,20.51,20.51A20.51,20.51,0,0,1,86.27,305.23Z",
    transform: "translate(-39.83 -34.98)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M322,169.54a18.27,18.27,0,0,1-18.17,18.37H148.57a18.27,18.27,0,0,1-18.17-18.37h0a18.27,18.27,0,0,1,18.17-18.37H303.78A18.27,18.27,0,0,1,322,169.54Z",
    transform: "translate(-39.83 -34.98)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M318.47,169.54a15.2,15.2,0,0,1-15.21,15.2H149.78a15.19,15.19,0,0,1-15.2-15.2h0a15.19,15.19,0,0,1,15.2-15.2H303.26a15.2,15.2,0,0,1,15.21,15.2Z",
    transform: "translate(-39.83 -34.98)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M152.79,165.88l-1.56,1.38a2.2,2.2,0,0,0-1.67-1.15,1,1,0,0,0-.68.23.61.61,0,0,0-.26.5.86.86,0,0,0,.18.52,13.76,13.76,0,0,0,1.55,1.42c.8.67,1.29,1.1,1.46,1.27a4.43,4.43,0,0,1,.91,1.24,3.2,3.2,0,0,1,.26,1.29,2.94,2.94,0,0,1-.94,2.25,3.41,3.41,0,0,1-2.45.88,3.7,3.7,0,0,1-2.06-.57,4.72,4.72,0,0,1-1.5-1.82l1.77-1.07c.53,1,1.14,1.46,1.84,1.46a1.36,1.36,0,0,0,.91-.31,1,1,0,0,0,.37-.73,1.29,1.29,0,0,0-.28-.75,8.15,8.15,0,0,0-1.23-1.15,12.15,12.15,0,0,1-2.33-2.28,2.8,2.8,0,0,1-.53-1.59,2.61,2.61,0,0,1,.88-2,3,3,0,0,1,2.16-.82,3.5,3.5,0,0,1,1.58.38A5.73,5.73,0,0,1,152.79,165.88Z",
    transform: "translate(-39.83 -34.98)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M155,164.38h6v2.06h-3.95v2H161v2h-3.95v2.91H161v2.07h-6Z",
    transform: "translate(-39.83 -34.98)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M166.37,164.38h2.14l4.25,11.06h-2.19l-.86-2.28H165.2l-.9,2.28h-2.19Zm1.09,2.93-1.49,3.8h3Z",
    transform: "translate(-39.83 -34.98)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M174.53,164.38h2.23a7.58,7.58,0,0,1,2.61.32,2.64,2.64,0,0,1,1.25,1.09,3.32,3.32,0,0,1,.48,1.8,3.06,3.06,0,0,1-.53,1.82,3.12,3.12,0,0,1-1.57,1.11l2.62,4.92h-2.3l-2.49-4.69h-.19v4.69h-2.11Zm2.11,4.32h.66a2.62,2.62,0,0,0,1.38-.26,1,1,0,0,0,.38-.88,1,1,0,0,0-.19-.63,1,1,0,0,0-.5-.38,3.71,3.71,0,0,0-1.16-.12h-.57Z",
    transform: "translate(-39.83 -34.98)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M193.49,166.32l-1.47,1.4a4.6,4.6,0,0,0-3.39-1.58,3.69,3.69,0,0,0-3.75,3.75,4,4,0,0,0,.48,2,3.37,3.37,0,0,0,1.36,1.34,3.92,3.92,0,0,0,1.95.49,4,4,0,0,0,1.68-.34A6.05,6.05,0,0,0,192,172.1l1.42,1.49a7.81,7.81,0,0,1-2.31,1.66,6.32,6.32,0,0,1-2.49.46,5.71,5.71,0,0,1-4.22-1.63,5.65,5.65,0,0,1-1.65-4.19,5.72,5.72,0,0,1,.75-2.94,5.54,5.54,0,0,1,2.14-2.07,6.09,6.09,0,0,1,3-.78,6.43,6.43,0,0,1,4.82,2.22Z",
    transform: "translate(-39.83 -34.98)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M195.32,164.38h2.14v4.17h3.69v-4.17h2.13v11.06h-2.13v-4.85h-3.69v4.85h-2.14Z",
    transform: "translate(-39.83 -34.98)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M206.7,173.29a1.14,1.14,0,0,1,.83.35,1.11,1.11,0,0,1,.35.83,1.18,1.18,0,1,1-2.36,0,1.1,1.1,0,0,1,.34-.83A1.15,1.15,0,0,1,206.7,173.29Z",
    transform: "translate(-39.83 -34.98)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M211,173.29a1.14,1.14,0,0,1,.83.35,1.11,1.11,0,0,1,.35.83,1.18,1.18,0,1,1-2.36,0,1.1,1.1,0,0,1,.34-.83A1.15,1.15,0,0,1,211,173.29Z",
    transform: "translate(-39.83 -34.98)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M215.31,173.29a1.15,1.15,0,0,1,.84.35,1.11,1.11,0,0,1,.35.83,1.19,1.19,0,0,1-2.37,0,1.11,1.11,0,0,1,.35-.83A1.14,1.14,0,0,1,215.31,173.29Z",
    transform: "translate(-39.83 -34.98)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M271.89,174.3a10.91,10.91,0,0,1,7.6-14.88,12.63,12.63,0,0,1,22-7.19,18.86,18.86,0,0,1,32.69,18.56,14.37,14.37,0,0,1-4.57,28H282.1a14.37,14.37,0,0,1-10.21-24.49Z",
    transform: "translate(-39.83 -34.98)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 309.45,
    y: 136.03,
    width: 12.04,
    height: 48.59,
    transform: "translate(-78.13 133.96) rotate(-28.34)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 304.37,
    y: 146.14,
    width: 12.04,
    height: 9.51,
    transform: "translate(-74.26 130.47) rotate(-28.34)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M272.84,133.15a24.62,24.62,0,1,0,10-33.37A24.61,24.61,0,0,0,272.84,133.15Zm5.58-3a18.29,18.29,0,1,1,24.77,7.41A18.29,18.29,0,0,1,278.42,130.14Z",
    transform: "translate(-39.83 -34.98)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M278.42,130.14a18.29,18.29,0,1,0,7.41-24.78A18.29,18.29,0,0,0,278.42,130.14Z",
    transform: "translate(-39.83 -34.98)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 309.86,
    y: 137.45,
    width: 5.98,
    height: 48.59,
    transform: "translate(-79.12 132.91) rotate(-28.34)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 304.77,
    y: 147.56,
    width: 5.98,
    height: 9.51,
    transform: "translate(-75.25 129.37) rotate(-28.34)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M282.82,99.78l3,5.58a18.29,18.29,0,0,0,17.36,32.19l3,5.58a24.63,24.63,0,0,1-23.38-43.35Z",
    transform: "translate(-39.83 -34.98)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M285.83,105.36l17.36,32.19a18.29,18.29,0,0,1-17.36-32.19Z",
    transform: "translate(-39.83 -34.98)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M336.5,188.42a9.85,9.85,0,0,1-9.85,9.84H294.12A9.84,9.84,0,0,1,291,179.09a12.92,12.92,0,0,1,22.39-12.72,8.65,8.65,0,0,1,15.05,4.93,7.46,7.46,0,0,1,5.8,7.27,7.3,7.3,0,0,1-.6,2.92A9.8,9.8,0,0,1,336.5,188.42Z",
    transform: "translate(-39.83 -34.98)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M367.28,217.89c11.34,32.31,15.27,47.61,1.3,52.56-12.8,4.53-29.71,11.85-40.19,8.76-11.38-3.36-29.26-25.68-29.26-25.68l.12-.13-13.87-12.66a7.35,7.35,0,1,1,9.91-10.85l13.8,12.6h0c4.69,4.13,3-2.12,1.72-5.79,0,0-.05-.08-.07-.13l-17-48A6.87,6.87,0,0,1,306.67,184L323,230.09l1.63-.53-10.5-29.63a7.76,7.76,0,0,1,14.64-5.18l10.63,30,1.3-.42-9.5-26.82a7.19,7.19,0,0,1,13.55-4.8l9.62,27.17,1.27-.4-5.36-15.12a5.77,5.77,0,0,1,10.88-3.85Z",
    transform: "translate(-39.83 -34.98)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 336.5,
    y: 264.92,
    width: 37.33,
    height: 36.94,
    transform: "translate(-114.08 99.89) rotate(-19.51)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 336.12,
    y: 277.82,
    width: 42.52,
    height: 23.67,
    transform: "translate(-116.03 100.96) rotate(-19.5)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 334.36,
    y: 284.86,
    width: 49.28,
    height: 18.74,
    transform: "translate(-117.48 101.8) rotate(-19.51)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M259.1,85.79a9.19,9.19,0,0,0-6.41-12.55,10.66,10.66,0,0,0-18.53-6.06,15.9,15.9,0,0,0-27.55,15.65,12.11,12.11,0,0,0,3.85,23.6h40a12.11,12.11,0,0,0,8.61-20.64Z",
    transform: "translate(-39.83 -34.98)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M256.74,62.75A27.77,27.77,0,1,1,229,35,27.77,27.77,0,0,1,256.74,62.75Z",
    transform: "translate(-39.83 -34.98)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M252.55,62.75A23.58,23.58,0,1,1,229,39.17,23.58,23.58,0,0,1,252.55,62.75Z",
    transform: "translate(-39.83 -34.98)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M248,62.75A19.07,19.07,0,1,1,229,43.68,19.07,19.07,0,0,1,248,62.75Z",
    transform: "translate(-39.83 -34.98)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M243.62,62.75A14.65,14.65,0,1,1,229,48.1,14.65,14.65,0,0,1,243.62,62.75Z",
    transform: "translate(-39.83 -34.98)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M239.06,62.75A10.09,10.09,0,1,1,229,52.67,10.08,10.08,0,0,1,239.06,62.75Z",
    transform: "translate(-39.83 -34.98)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M235,62.75a6,6,0,1,1-6-6A6,6,0,0,1,235,62.75Z",
    transform: "translate(-39.83 -34.98)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 234.42,
    y: 52.86,
    width: 31.16,
    height: 2.1,
    transform: "translate(-40.22 71) rotate(-23.92)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "201.71 28.88 195.97 25.41 197.12 18.51 189.04 28.29 201.71 28.88"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "228.52 14.57 225.03 12.46 225.73 8.26 221.09 10.31 220.32 14.43 223.81 16.65 228.52 14.57"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M171.81,52.39H159.13V48.5a7.53,7.53,0,0,0-.49-3.47,1.77,1.77,0,0,0-1.62-.75,2.09,2.09,0,0,0-1.87,1,5.86,5.86,0,0,0-.63,3.05,8.72,8.72,0,0,0,.71,4c.46.89,1.74,2,3.86,3.21q9.12,5.41,11.49,8.88t2.36,11.19c0,3.73-.44,6.49-1.31,8.26a10.28,10.28,0,0,1-5.08,4.46,20.05,20.05,0,0,1-8.75,1.8A19.61,19.61,0,0,1,148.44,88a10.21,10.21,0,0,1-5.07-5.29,27.1,27.1,0,0,1-1.2-9.11V70.19h12.68v6.39a8.5,8.5,0,0,0,.53,3.79,2.06,2.06,0,0,0,1.9.85,2.24,2.24,0,0,0,2-1.07A6.18,6.18,0,0,0,160,77q0-4.64-1.26-6.06a40.43,40.43,0,0,0-6.39-4.77,62.8,62.8,0,0,1-6.75-4.9A11.52,11.52,0,0,1,142.83,57a18.7,18.7,0,0,1-1.08-6.88q0-6,1.54-8.82a10.32,10.32,0,0,1,5-4.36,19.85,19.85,0,0,1,8.31-1.57,21.57,21.57,0,0,1,9.06,1.72,9.45,9.45,0,0,1,5,4.33c.81,1.74,1.22,4.69,1.22,8.87Z",
    transform: "translate(-39.83 -34.98)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177.21,36.5H200V47h-9.11V57h8.53V67h-8.53V78.49h10V89H177.21Z",
    transform: "translate(-39.83 -34.98)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M259.73,90.59A7.05,7.05,0,0,0,254.81,81a8.18,8.18,0,0,0-14.22-4.66,12.2,12.2,0,0,0-21.15,12,9.3,9.3,0,0,0,2.95,18.12h30.73a9.29,9.29,0,0,0,6.61-15.84Z",
    transform: "translate(-39.83 -34.98)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo);
export default __webpack_public_path__ + "static/media/seo.56b3aaed4f3d98fc42a52fb11bf45516.svg";
export { ForwardRef as ReactComponent };